import {getCompatibleImageFileExtension} from '@Utils/image.util';
import {repoURL} from '@Libraries/s3-library';
import {getWriteBucket} from '@Utils/s3.util';
import {
  getUpscaledVariantBaseName,
  ImageItemSource,
  type ImageItemSourceType,
  isSourcePMWStockImage,
  UPSCALED_USER_IMAGE_EXTENSION,
  UPSCALED_USER_IMAGE_VARIANT_SUFFIX,
} from '@Libraries/image-item.library';
import {getUrlForPMWStockImage} from '@Libraries/pmw-stock-media-library';
import {MediaItemSizeType} from '@Libraries/s3-library';

// TODO: Remove this and only have user-image-library.ts. Reanme that to a better name too
/**
 * S3 directory names for images
 * @type {string}
 */
const IMAGE_BUCKET = 'uploads';
const IMAGE_THUMB_SIZE_BUCKET = `${IMAGE_BUCKET}/thumbs`;

export const repoImageScreenURL = (hashedFilename: string, fileExtension: string): string => {
  if (hashedFilename && fileExtension) {
    return repoURL(`${IMAGE_BUCKET}/${hashedFilename}.${getCompatibleImageFileExtension(fileExtension)}`, getWriteBucket());
  }
  return '';
};

export const repoImageThumbURL = (hashedFilename: string, fileExtension: string, isUpscaled = false, source: ImageItemSourceType = ImageItemSource.UPLOAD): string => {
  if (!hashedFilename) {
    return '';
  }
  let targetFileExtension = fileExtension;
  const variantBaseName = getUpscaledVariantBaseName(hashedFilename, isUpscaled, source);
  if (variantBaseName !== null) {
    return repoURL(
      `${IMAGE_THUMB_SIZE_BUCKET}/${variantBaseName}${UPSCALED_USER_IMAGE_VARIANT_SUFFIX}.${getCompatibleImageFileExtension(UPSCALED_USER_IMAGE_EXTENSION)}`,
      getWriteBucket()
    );
  }
  if (!targetFileExtension) {
    return '';
  }
  if (targetFileExtension === 'svg') {
    targetFileExtension = 'png';
  }
  return repoURL(`${IMAGE_THUMB_SIZE_BUCKET}/${hashedFilename}.${getCompatibleImageFileExtension(targetFileExtension)}`, getWriteBucket());
};

/**
 * Thumb URL for an image that may live in the user-uploads repo or a PMW stock repo,
 * depending on its source (e.g. a QR logo picked from uploads vs the stock icons panel).
 */
export const getImageThumbUrlForSource = (hashedFilename: string, fileExtension: string, source: ImageItemSourceType): string => {
  if (isSourcePMWStockImage(source)) {
    return getUrlForPMWStockImage(hashedFilename, source, MediaItemSizeType.THUMB);
  }
  return repoImageThumbURL(hashedFilename, fileExtension);
};
